import axios from 'axios';
import {BACKEND_BASEURL} from "@/config/config";


let configBackendBaseUrl = "";
let $log;

// used by app.use
export default function setup(app) {
  // configBackendBaseUrl = app.$appconfig.BACKEND_BASEURL;
  configBackendBaseUrl = BACKEND_BASEURL;
  $log = app.$log;
}

export async function getMaintainersForCommunity(community) {

  try {
    const response = await axios
      .get(`${configBackendBaseUrl}accountManagement/${community.ecn}/realm-maintainers`);
    return response.data;
  } catch (error) {
    $log.error('Error during getMaintainersForCommunity:', error);
    throw error;
  }


}
